import apiClient from "../api/apiClient"
import { InventoryStock, StockLedgerEntry, StockMovementType, StockReferenceType } from "../../types"

export interface StockLedgerParams {
  sku_id?: string
  movement_type?: StockMovementType
  reference_type?: StockReferenceType
  from_date?: string
  to_date?: string
  page?: number
  limit?: number
}

export interface StockLedgerResponse {
  entries: StockLedgerEntry[]
  total: number
  page: number
  pages: number
}

export const inventoryService = {
  async getInventoryStock(params?: {
    sku_id?: string
    search?: string
  }): Promise<InventoryStock[]> {
    const response = await apiClient.get<InventoryStock[]>("/admin/inventory", { params })
    return response.data
  },

  async getStockLedger(params?: StockLedgerParams): Promise<StockLedgerResponse> {
    const response = await apiClient.get<StockLedgerResponse>("/admin/inventory/ledger", {
      params,
    })
    return response.data
  },
}
